import { PolicyOverdueDebtDetail, PolicyOverdueDebtHeaders } from "../../../../shared/interfaces/services/policy-overdue-debt-service";
import { parseCurrencyValue } from "../../../../shared/utils/parseCurrencyValue";

export const mapOfPoliciesOverdueDebt = (policies : Array<PolicyOverdueDebtDetail> = [], policyOverdueDebtHeaders: PolicyOverdueDebtHeaders) => policies.map(({
    rama,
    poliza,
    suplemento,
    asegurado,
    formaDePago,
    impagoDesde,
    moneda,
    deudaMasDe90Dias,
    deudaHasta90Dias,
    deudaHasta60Dias,
    deudaHasta30Dias,
    deudaPorVencer,
}) => ({
    'Rama': rama ?? '',
    'Num. Póliza': poliza ?? '',
    'Sup.': suplemento  ?? '',
    'Asegurado': asegurado  ?? '',
    'F. de Pago': formaDePago  ?? '',
    'Impago Desde': impagoDesde  ?? '',
    'Moneda': moneda  ?? '',
    'Deuda Anterior': parseCurrencyValue(deudaMasDe90Dias) ?? '',
    [`Deuda ${policyOverdueDebtHeaders?.firstColumn ?? ''}`]: parseCurrencyValue(deudaHasta90Dias) ?? '',
    [`Deuda ${policyOverdueDebtHeaders?.secondColumn ?? ''}`]: parseCurrencyValue(deudaHasta60Dias) ?? '',
    [`Deuda ${policyOverdueDebtHeaders?.thirdColumn ?? ''}`]: parseCurrencyValue(deudaHasta30Dias) ?? '',
    'A Vencer': parseCurrencyValue(deudaPorVencer) ?? '',
}));